import { render, staticRenderFns } from "./AIInfoModal.vue?vue&type=template&id=4a480d48&scoped=true&"
import script from "./AIInfoModal.vue?vue&type=script&lang=ts&"
export * from "./AIInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a480d48",
  null
  
)

export default component.exports